export const addCnameModal = {
  extend: ['ModalWindow', 'Form'],
  props: {
    width: '100%',
    maxWidth: 'I'
  },
  tag: 'form',
  state: {
    cname: '',
    validationMessage: ''
  },
  ModalHeader: {
    title: 'Go to your DNS manager'
  },
  Flex: {
    overflow: 'auto',
    padding: 'A',
    minWidth: '100%',
    flow: 'column',
    flexAlign: 'flex-start space-between',
    gap: 'B3',
    childProps: {
      width: '50%'
    },
    InputField: {
      Title: {
        text: '{{ publish.dns.cname | polyglot }}'
      },
      Input: {
        value: '{{ cname }}',
        required: true,
        placeholder: 'eg. test.com or www.test.com or sub.test.com',
        onInput: (ev, el, st) => {
          const { node } = el
          const { value } = node

          const regex =
            /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/gu

          if (!regex.test(value)) {
            st.replace({
              cname: null,
              validationMessage: 'Invalid cname'
            })

            return
          }

          st.update({
            validationMessage: '',
            cname: value
          })
        }
      },
      Label: {
        show: (ev, st) => st.validationMessage,
        color: 'red',
        text: (ev, st) => st.validationMessage
      }
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      reverse: true,
      text: '{{ common.action.save | polyglot }}',
      ':hover': {
        cursor: 'pointer'
      }
    }
  },
  onSubmit: async (e, el, st, ctx) => {
    e.preventDefault()
    if (!st.cname) {
      return
    }

    const urlParams = new URLSearchParams(ctx.window.location.search)
    const type = urlParams.get('type')
    const domainName = urlParams.get('domainName')

    if (!type || !domainName) {
      return
    }

    const { root } = st
    if (root && root.domains && root.domains[type]) {
      if (root.domains[type].cname === st.cname) {
        st.replace({
          validationMessage: `CNAME with this name is already added for '${type}' environment`
        })
        return
      }
    }
  }
}
